<template>
  <div o-Container o-Container-App id="charts-container">
    <van-nav-bar title="全局监控" left-arrow @click-left="onClickLeft" v-bind="{fixed:true}"/>
    <div class="content">
      <div class="containerMask"></div>

      <div>VUE-Video-Player</div>
      <!--  webkit-playsinline="" playsinline=“true” 解决一播放就是全屏  webkit-playsinline="true" x5-playsinline="true" -->
      <video-player ref="videoPlayer" class="video-player vjs-custom-skin"
                    :playsinline="true"
                    :options="playerOptions" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)"/>
      <button v-on:click="onPlay" style="height: 50px;">开始播放</button>
      <button v-on:click="onPause" style="height: 50px;">暂停播放</button>
      <div>HK Video</div>
<!--      <iframe src="https://open.ys7.com/view/h5/491b5bab32eb4540ba9197e0bfda69bd" width="100%" height="500"></iframe>-->
      <iframe src="https://open.ys7.com/ezopen/h5/live?autoplay=0&audio=1&accessToken=at.378ejbd19a919tse7x7hp06607o81aah-6t59c94w25-02dkscp-ybef8cc5h&deviceSerial=C07569549&channelNo=2#" width="100%" height="500"></iframe>
    </div>
  </div>
</template>

<script>
  export default {
    name: "mms_engine_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        HLS: null,
        RTMP: null,
        playerOptions: {
          // playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度，直播不需要。
          autoplay: false, // 如果true,浏览器准备好时开始回放，节约流量不必要的开支，app端点开才能看。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          // 解决浪费资源问题 一打开网页就加载mp4 造成不必要的损失，所以不要用auto，用none。
          preload: 'none', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            // {
            //   type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm' // url地址
            // },
            {
              type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
              src: 'http://hls01open.ys7.com/openlive/491b5bab32eb4540ba9197e0bfda69bd.m3u8'
            }
          ],
          hls: true,
          poster: 'http://saas.smart.guodongiot.com:7078/static/skin/default/admin/home/img/GDSmart-min.png', // 你的封面地址
          width: document.documentElement.clientWidth, // 播放器宽度
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true // 全屏按钮
          }
        },
      }
    },
    // 活动事件，写在这里的好处是不管是第一次创建还是后退回来，都会触发这个事件
    // 比较典型的就是列表组件，返回的时候往往是需要刷新的。
    activated: function () {
      document.documentElement.scrollTop = 0;
    },
    created() {

    },
    updated: function () {

    },
    computed: {
      // 监听整个Vue-Play组件，时刻保持最新。
      player() {
        return this.$refs.videoPlayer.player//自定义播放
      }
    },
    mounted() {
      let o = this;
      setTimeout(function () {
        o.init();
      }, 1000);
    },
    methods: {
      onClickLeft() {
        this.octopus.router.jump('/APP/Main/Home/Page')
      },
      click: function (param) {
      },
      init: function () {
        // let player = new this.$Plug.HK.EZUIPlayer('myPlayer_HLS');
        // this.HLS = player;
        // // this.HLS.on('log', log);
        //
        //
        // this.RTMP = new this.$Plug.HK.EZUIPlayer('myPlayer_RTMP');
        // // player_RTMP.on('log');
        //
        //
        // // console.log(this.$EZUIPlayer);
        // // $('#myPlayer').attr("src", "http://hls.open.ys7.com/openlive/f01018a141094b7fa138b9d0b856507b.m3u8");
        // // let player = new this.$Plug.HK.EZUIPlayer('myPlayer');
        // // // 日志
        // // player.on('log', log);
        // //
        // function log(str) {
        //   let div = document.createElement('DIV');
        //   div.innerHTML = JSON.stringify(str);
        //   document.body.appendChild(div);
        // }
        //
        // //
        // // $("#stop").click(function () {
        // //   player.stop();
        // // })


      },
      playHLS: function () {
        window['CKobject'] = null;
        // let player = new this.$Plug.HK.EZUIPlayer('myPlayer_HLS');
        // player.play();
        this.HLS.play();
      },
      playRTMP: function () {
        // alert("321");
        this.RTMP.play();
      },
      onPlay: function () {
        this.player.play();
      },
      onPause: function () {
        this.player.pause();
      },
      onPlayerPlay: function (player) {
        console.log(player);
        this.octopus.tips.warning("开始播放。");
      },
      onPlayerPause: function (player) {
        console.log(player);
        this.octopus.tips.warning("开始播放。");
      }
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/APP/Monitor/Main/PageBack.vue